import React, { useEffect, useState } from 'react';
import { BaseConfig } from '../BaseConfig';
import TalksQuestionButton, { TalksQuestionButtonsConfig } from '../helpers/TalksQuestionButton';
import { UIProperties } from '../UIProperties';
import SubmitButton from '../helpers/SubmitButton';
import './TransformUI.css'
import PainScaleUI from './PainScaleUI';
import SimpleFeedbackUI from './SimpleFeedbackUI';
import BaseScenario from '../../cvp-webgames-core/Scenario/BaseScenario';
import { playSound, setFocus } from '../../misc/tools';

const TransformUI = (props: UIProperties<TransformUIConfig>) => {
	const [forceUpdate, setForceUpdate] = useState(false);
	const [feedbackToShow, setFeedbackToShow] = useState(null);
	var timeout: any = undefined;
	if (props.parameters.goBack2) {
		props.parameters.goBack2 = false;
	}
	(props.parameters as any).updateVisibility = (isVisible: boolean, onDone: () => void) => {
		setTimeout(() => {
			var el = document.getElementById(props.id);
			if (!el) {
				return;
			}
			playSound('./assets/audio/Menu_Slide');
			el.classList.remove('ta-container-animation');
			el.classList.remove('ta-container-animation-reverse');

			if (isVisible) {
				console.log('showing ' + props.id);
				el.classList.add('ta-container-animation');
			} else {
				console.log('removing ' + props.id);
				el.classList.add('ta-container-animation-reverse');
			}

			setTimeout(() => {
				(window as any)[props.id + 'animation'] = undefined;
				onDone();
			}, 500);
		}, 0);
	}
	useEffect(() => {
		var extBottom1 = document.getElementById(props.id + 'extBottom1');
		var extBottom2 = document.getElementById(props.id + 'extBottom2');

		if (extBottom1 && extBottom2) {
			setTimeout(() => {
				extBottom1.classList.add('animation2');
				extBottom2.classList.add('animation2');
			}, 500);
		}

		var top = document.getElementById(props.id + 'extTop');

		if (top) {

			setTimeout(() => {
				top.style.right = '-1270px';
				top.style.visibility = 'visible';
				top.classList.add('animation3');
			}, 1000);
		}
	})
	return (
		<div>
			<div>
				{props.parameters.extTop ? (
					<div style={{
						position: 'absolute',
						top: '115px',
						width: '1267px',
						right: '645px',
						height: '919px',
						overflow: 'hidden'
					}} className="modal-disable-select">
						<div id={props.id + 'extTop'} style={{
							position: 'relative',
							top: '0',
							right: '0',
							width: '1240px',
							visibility: 'hidden'
						}}>
							<div>
								<img src="./assets/images/general/components/talks-actions/window_ext_top.png" />
								{props.parameters.extImg ? (props.parameters.extTopPx ? (
									<div style={{
										position: 'absolute',
										top: props.parameters.extTopTop,
										left: '50%',
										width: props.parameters.extTopWidth,
										transform: 'translate(-50%, 0)'
									}}>
										<img src={'./assets/images/general/components/talks-actions/extended/' + props.parameters.extImg + '.png'} />
									</div>) : (
									<div style={{
										position: 'absolute',
										top: '80px',
										left: '50%',
										width: '820px',
										transform: 'translate(-50%, 0)'
									}}>
										<img src={'./assets/images/general/components/talks-actions/extended/' + props.parameters.extImg + '.png'} />
									</div>
								)) : (null)}

								{props.parameters.extTopVideo ? (
									<div style={{
										position: 'absolute',
										top: '85px',
										left: '50%',
										width: '840px',
										transform: 'translate(-50%, 0)'
									}}>
										<video style={{
											width: '100%'
										}} src={props.parameters.extTopVideo} playsInline={true} autoPlay={true} muted={true} loop={true}></video>
									</div>
								) : (null)}
							</div>
							<div style={{
								position: 'absolute',
								top: '614px',
								left: '0',
								overflow: 'none'
							}}>
								<img src="./assets/images/general/components/talks-actions/window_ext_bottom.png" />
								<div style={{
									position: 'absolute',
									top: '10px',
									left: '54px',
									width: '1121px',
									height: '239px',
									overflow: 'hidden',
									pointerEvents: 'all'
								}}>
									<p tabIndex={0} id={'first-object-transform'} style={{
										margin: 0,
										textAlign: 'center',
										color: 'white'
									}} className="title-font" dangerouslySetInnerHTML={{ __html: props.parameters.extText }}></p>
								</div>
							</div>
						</div>
					</div>) : (<div></div>)}
				{props.parameters.extBottom ? (<div style={{
					position: 'absolute',
					top: '77px',
					width: '1266px',
					height: '919px',
					overflow: 'hidden'
				}} >
					<div id={props.id + 'extBottom1'} className="ext-text-container" style={{
						right: '-1230px'
					}}>
						<img src="./assets/images/general/components/talks-actions/window_ext_bottom.png" />
					</div><div id={props.id + 'extBottom2'} className="ext-text-container" style={{
						right: '-1230px'
					}}>
						<img src="./assets/images/general/components/talks-actions/window_ext_bottom.png" />
						<div className="ext-text">
							<p tabIndex={0} id={'first-object-transform'} dangerouslySetInnerHTML={{ __html: props.parameters.extText }}></p>
						</div>
					</div>
				</div>) : (<div></div>)}
			</div>
			<div id={props.id} className="tr-main ta-container-animation" >
				<p className="tr-title">{props.parameters.toptitle}</p>
				<img src="./assets/images/general/components/talks-actions/window_side_large_blank.png" />

				<div style={{
					position: 'absolute',
					top: props.parameters.toppx,
					left: '50px',
					width: '570px',
					transform: props.parameters.move,
					transition: props.parameters.time
				}}>

					<img style={{
						pointerEvents: 'none'
					}} src='./assets/images/general/components/talks-actions/bar_main.png' />

					<p tabIndex={0} style={{
						position: 'absolute',
						margin: '10px',
						top: '10px',
						left: '35px',
						width: '73%',
						fontSize: '25px',
						color: 'white',
						textAlign: 'left'
					}}>{props.parameters.titletext}</p>
				</div>

				{props.parameters.isTalks ? (
					<div className="tr-fade-in tr-quiz-limit">
						{props.parameters.quiz.map((item: TalksQuestionUIQuizConfig, index: number) => {
							var currentTalkForce: any = [];
							return (
								<div className="tr-quiz tr-border" style={{
									//top: item.quiztop,
									top: ((5 * index) + (160 + (50 * item.prequizheight))) + 'px',
									height: (160 + (50 * item.quizheight)) + 'px',
								}}>
									<div>
										<img style={{
											position: 'absolute',
											top: '-10px',
											height: '150px',
											left: '3px',
											pointerEvents: 'none'
										}} src='./assets/images/general/components/questions/window_questions.png' />

										<p tabIndex={0} id={index === 0 && !props.parameters.extText ? 'first-object-transform' : null} style={{
											position: 'absolute',
											margin: '10px',
											top: '10px',
											left: '10px',
											fontSize: '35px',
											color: 'white',
											textAlign: 'left'
										}}>{item.talktext1}</p>

										<p tabIndex={0} style={{
											position: 'absolute',
											margin: '10px',
											top: '60px',
											color: 'white',
											left: '20px',
											fontSize: '25px',
											textAlign: 'left'
										}}>{item.talktext2}</p>
									</div>
									{item.talks.map((item2: TalksQuestionUIRightConfig, index2: number) => {
										return (
											<div>
												<TalksQuestionButton parameters={{
													top: item2.buttontop,
													text: item2.buttontext,
													highlightOnHover: true,
													isDisabled: props.parameters.loadQuiz,
													onInit: (config: TalksQuestionButtonsConfig) => {
														if (config.onForceIsSelected) {
															currentTalkForce.push(config.onForceIsSelected);
														}
													},
													onClickedd: () => {
														if (props.parameters.quiz[index].binaryq) {
															for (var i = 0; i < currentTalkForce.length; i++) {
																if (i !== index2) {
																	currentTalkForce[i](false);
																}
															}
														}
														props.parameters.quiz[index].talks[index2].isSelected = !props.parameters.quiz[index].talks[index2].isSelected;
														if (!props.parameters.quiz[index].selectedTalkIndices) {
															props.parameters.quiz[index].selectedTalkIndices = [];
														}
														var indexOfTalk = props.parameters.quiz[index].selectedTalkIndices.indexOf(index2);

														if (indexOfTalk === -1) {
															props.parameters.quiz[index].selectedTalkIndices.push(index2);
														} else {
															props.parameters.quiz[index].selectedTalkIndices.splice(index2, 1);
														}

														if (item2.onClicked) {
															item2.onClicked();
														}

														setForceUpdate(!forceUpdate);

													}
												}} />
											</div>
										);
									})}

								</div>
							);
						})}

						{props.parameters.isPainScale ? (
							<div className="tr-quiz tr-border" style={{
								height: '640px'
							}}>
								<div>
									<img style={{
										position: 'absolute',
										top: '-10px',
										height: '150px',
										left: '3px',
										pointerEvents: 'none'
									}} src='./assets/images/general/components/questions/window_questions.png' />

									<p tabIndex={0} id='first-object-transform' style={{
										position: 'absolute',
										margin: '10px',
										top: '10px',
										left: '10px',
										fontSize: '35px',
										color: 'white',
										textAlign: 'left'
									}}>Pain Assessment</p>

									<p tabIndex={0} style={{
										position: 'absolute',
										margin: '10px',
										top: '60px',
										left: '20px',
										fontSize: '25px',
										color: 'white',
										textAlign: 'left'
									}}>Pain Scale</p>
								</div>
								<PainScaleUI selectionChanged={(painLevel: number) => {
									props.parameters.painAssessment = painLevel;
								}}></PainScaleUI>
							</div>
						) : (null)}
					</div>
				) : (
					<div className="tr-fade-in" style={{
						position: 'absolute',
						top: '200px',
						left: '80px',
						width: '500px'
					}}>
						<img style={{
							pointerEvents: 'none'
						}} src='./assets/images/general/icons/vitals/window_vitals.png' />

						<img style={{
							position: 'absolute',
							top: '23px',
							left: '37px',
							width: '140px',
							pointerEvents: 'none'
						}} src={props.parameters.vitalimg} />

						<p tabIndex={0} style={{
							position: 'absolute',
							top: '0px',
							verticalAlign: 'middle',
							left: '210px',
							width: '50%',
							fontSize: '33px',
							color: 'white',
							textAlign: 'center'
						}}>{props.parameters.vitaltext}</p>
					</div>
				)}

				{props.parameters.isTalks ? (
					<div>
						{/* <p tabIndex={0} role='text' id={props.parameters.loadQuiz || (props.parameters.quiz && props.parameters.quiz.filter(q => q.selectedTalkIndices && q.selectedTalkIndices.length > 0).length !== props.parameters.quiz.length) ? 'last-object-transform' : null} aria-label='end of content'></p> */}

						<SubmitButton parameters={{
							id: props.parameters.loadQuiz || (props.parameters.quiz && props.parameters.quiz.filter(q => q.selectedTalkIndices && q.selectedTalkIndices.length > 0).length !== props.parameters.quiz.length) ? null : 'last-object-transform',
							top: '890px',
							left: '10%',
							width: '50%',
							highlightOnHover: true,
							isDisabled: props.parameters.loadQuiz || (props.parameters.quiz && props.parameters.quiz.filter(q => q.selectedTalkIndices && q.selectedTalkIndices.length > 0).length !== props.parameters.quiz.length),
							onClicked: () => {
								playSound('./assets/audio/Menu_Slide');

								var rootEl = document.getElementById(props.id);
								var extBottom1 = document.getElementById(props.id + 'extBottom1');
								var extBottom2 = document.getElementById(props.id + 'extBottom2');

								const onDone = () => {
									if (props.parameters.quiz) {
										for (var qIndx = 0; qIndx < props.parameters.quiz.length; qIndx++) {
											var quiz = props.parameters.quiz[qIndx];
											if (quiz.incorrectFeedback) { //only validate for quizes with incorrect feedback
												var correctAnswers = quiz.talks.filter(t => t.isCorrect);
												var selectedCorrectAnswers = quiz.talks.filter(t => t.isCorrect && t.isSelected);
												var selectedAnswers = quiz.talks.filter(t => t.isSelected);
												var isCorrect = correctAnswers.length === selectedAnswers.length && selectedCorrectAnswers.length === selectedAnswers.length;
												if (!isCorrect) {
													setFeedbackToShow(quiz.incorrectFeedback);
													return;
												}
											}
											else if (quiz.setFailed) { //only validate for quizes with fail state
												var correctAnswers = quiz.talks.filter(t => t.isCorrect);
												var selectedCorrectAnswers = quiz.talks.filter(t => t.isCorrect && t.isSelected);
												var selectedAnswers = quiz.talks.filter(t => t.isSelected);
												var isCorrect = correctAnswers.length === selectedAnswers.length && selectedCorrectAnswers.length === selectedAnswers.length;
												if (!isCorrect) {
													quiz.failedOnDone();
													return;
												}
												else {
													quiz.passedOnDone();
													return;
												}
											}
										}
									}

									if (props.parameters.isPainScale) {
										if (typeof props.parameters.painAssessment === 'undefined') {
											props.parameters.painAssessment = 0;
										}
									}

									props.parameters.onSubmit(props.parameters);
								}

								var top = document.getElementById(props.id + 'extTop');
								if (top) {
									top.classList.remove('animation3');
									top.classList.add('animation3-reverse');
									setTimeout(() => {
										rootEl.classList.remove('ta-container-animation');
										rootEl.classList.add('ta-container-animation-reverse');
										setTimeout(() => {
											onDone();
										}, 500);
									}, 500);
								} else if (extBottom1 && extBottom2) {
									extBottom1.classList.remove('animation2');
									extBottom2.classList.remove('animation2');
									extBottom1.classList.add('animation2-reverse');
									extBottom2.classList.add('animation2-reverse');

									setTimeout(() => {
										rootEl.classList.remove('ta-container-animation');
										rootEl.classList.add('ta-container-animation-reverse');
										setTimeout(() => {
											onDone();
										}, 500);
									}, 500);
								} else {
									rootEl.classList.remove('ta-container-animation');
									rootEl.classList.add('ta-container-animation-reverse');

									setTimeout(() => {
										onDone();
									}, 500);
								}
							}
						}} />
					</div>
				) : (
					<div>
						{/* <p tabIndex={0} id={props.parameters.loadQuiz ? 'last-object-transform' : null} aria-label='end of content' role='text'></p> */}
						<SubmitButton parameters={{
							id: props.parameters.loadQuiz ? null : 'last-object-transform',
							top: '890px',
							left: '10%',
							width: '50%',
							highlightOnHover: true,
							isDisabled: props.parameters.loadQuiz,
							onClicked: () => {
								playSound('./assets/audio/Menu_Slide');
								var rootEl = document.getElementById(props.id);
								var extBottom1 = document.getElementById(props.id + 'extBottom1');
								var extBottom2 = document.getElementById(props.id + 'extBottom2');

								const onDone = () => {
									if (props.parameters.quiz) {
										for (var qIndx = 0; qIndx < props.parameters.quiz.length; qIndx++) {
											var quiz = props.parameters.quiz[qIndx];
											if (quiz.incorrectFeedback) { //only validate for quizes with incorrect feedback
												var correctAnswers = quiz.talks.filter(t => t.isCorrect);
												var selectedCorrectAnswers = quiz.talks.filter(t => t.isCorrect && t.isSelected);
												var selectedAnswers = quiz.talks.filter(t => t.isSelected);
												var isCorrect = correctAnswers.length === selectedAnswers.length && selectedCorrectAnswers.length === selectedAnswers.length;
												if (!isCorrect) {
													setFeedbackToShow(quiz.incorrectFeedback);
													return;
												}
											}
											else if (quiz.setFailed) { //only validate for quizes with fail state
												var correctAnswers = quiz.talks.filter(t => t.isCorrect);
												var selectedCorrectAnswers = quiz.talks.filter(t => t.isCorrect && t.isSelected);
												var selectedAnswers = quiz.talks.filter(t => t.isSelected);
												var isCorrect = correctAnswers.length === selectedAnswers.length && selectedCorrectAnswers.length === selectedAnswers.length;
												if (!isCorrect) {
													quiz.failedOnDone();
													return;
												}
												else {
													quiz.passedOnDone();
													return;
												}
											}
										}
									}

									if (props.parameters.isPainScale) {
										if (typeof props.parameters.painAssessment === 'undefined') {
											props.parameters.painAssessment = 0;
										}
									}

									props.parameters.onSubmit(props.parameters);
								}

								var top = document.getElementById(props.id + 'extTop');

								if (top) {
									top.classList.remove('animation3');
									top.classList.add('animation3-reverse');
									setTimeout(() => {
										rootEl.classList.remove('ta-container-animation');
										rootEl.classList.add('ta-container-animation-reverse');
										setTimeout(() => {
											onDone();
										}, 500);
									}, 500);
								} else if (extBottom1 && extBottom2) {
									extBottom1.classList.remove('animation2');
									extBottom2.classList.remove('animation2');
									extBottom1.classList.add('animation2-reverse');
									extBottom2.classList.add('animation2-reverse');

									setTimeout(() => {
										rootEl.classList.remove('ta-container-animation');
										rootEl.classList.add('ta-container-animation-reverse');
										setTimeout(() => {
											onDone();
										}, 500);
									}, 500);
								} else {
									rootEl.classList.remove('ta-container-animation');
									rootEl.classList.add('ta-container-animation-reverse');

									setTimeout(() => {
										onDone();
									}, 500);
								}

							}
						}} />
					</div>)}

			</div>


			{feedbackToShow ? <SimpleFeedbackUI text={feedbackToShow} onClose={() => {
				setFeedbackToShow(null);
			}}></SimpleFeedbackUI> : (null)}
		</div>
	);
};

export interface TransformUIConfig extends BaseConfig {
	toptitle: string;
	toppx: string;
	move?: string;
	goBack2?: boolean;
	time?: string;
	loadQuiz?: boolean;
	titletext: string;
	vitaltext?: string;
	vitalimg?: string;
	isTalks?: boolean;
	painScaleMaxPoints?: number;
	painAssessment?: number;
	painScaleCorrect?: number;
	isPainScale?: boolean;
	onSubmit: (updatedConfig: TransformUIConfig) => void;
	quiz?: TalksQuestionUIQuizConfig[];
	extTop?: boolean;
	extBottom?: boolean;
	extImg?: string;
	extTopVideo?: string;
	extText?: string;
	extTopPx?: boolean;
	extTopTop?: string;
	extTopWidth?: string;
}

export interface TalksQuestionUIQuizConfig {
	quizheight: number;
	prequizheight: number;
	quiztop: string;
	maxPoints: number;
	talktext1?: string;
	talktext2?: string;
	incorrectFeedback?: string;
	binaryq?: boolean;
	setFailed?: boolean;
	selectedTalkIndices?: number[];
	talks?: TalksQuestionUIRightConfig[];
	failedOnDone?: () => void;
	passedOnDone?: () => void;
}

export interface TalksQuestionUIRightConfig {
	buttontop?: string;
	buttontext?: string;
	isCorrect?: boolean;
	isSelected?: boolean;

	onClicked?: () => void;
}

export default TransformUI;